(() => {
  const directory = document.querySelector('[data-lnw-brand-directory]');
  if (!directory) return;
  const input = directory.querySelector('[data-lnw-brand-directory-search]');
  const rows = [...directory.querySelectorAll('[data-lnw-directory-brand]')];
  const empty = directory.querySelector('[data-lnw-brand-directory-empty]');
  directory.querySelector('[data-lnw-brand-directory-controls]').hidden = false;
  input.addEventListener('input', () => {
    const needle = input.value.trim().normalize('NFKD').toLocaleLowerCase();
    let count = 0;
    rows.forEach(row => {
      row.hidden = !row.dataset.lnwDirectoryBrand.normalize('NFKD').toLocaleLowerCase().includes(needle);
      if (!row.hidden) count++;
    });
    empty.hidden = count !== 0;
  });
})();
